import React from "react";
import { Form } from "react-bootstrap";
import { OTPInputComponent } from "../LoginComp";
import { isTin, maxLength, sanitizeCode } from "./mfaCodeFormat";
import "./mfaOtp.css";

// Worded like production's OTP step for codes we send; the app's code names the app.
const LABELS = {
  email: "Please Enter Your 6-Digit OTP:",
  sms: "Please Enter Your 6-Digit OTP:",
  totp: "Enter the 6-digit code from your authenticator app",
};

// 6-digit codes (email, sms, totp) use the old login's own OTP boxes (Amar: reuse, don't invent;
// docs/specs/authenticator-mfa.md, "Code entry"). Their state is internal, so `key={method}` remounts
// them on a method switch. `onResend` shows its "Resend OTP in Ns" link.
const CodeInput = ({ method, value, onChange, onResend, disabled }) => {
  // SSN/TIN last 4: masked like a password, never autofilled or remembered by the browser.
  if (isTin(method)) {
    return (
      <Form.Group className="mb-3" controlId="mfa-tin">
        <Form.Label>Last 4 digits of your SSN or TIN</Form.Label>
        <Form.Control
          type="password"
          value={value}
          disabled={disabled}
          maxLength={maxLength(method)}
          inputMode="numeric"
          autoComplete="off"
          autoFocus
          onChange={(e) => onChange(sanitizeCode(method, e.target.value))}
        />
      </Form.Group>
    );
  }
  return (
    <div className="mb-2 mfa-otp">
      <OTPInputComponent
        key={method}
        label={LABELS[method]}
        setOtpEntered={onChange}
        onClick={onResend}
        showResend={Boolean(onResend)}
      />
    </div>
  );
};

export default CodeInput;
